import React from 'react';
import { Tag } from '@gerdau/hefesto/Tag';
import { EInvoiceStatus } from '../../../../../../store/ducks/invoices/types';

interface IInvoiceStatusColumnProps {
  status: EInvoiceStatus;
}

const InvoiceStatusColumn: React.FC<IInvoiceStatusColumnProps> = ({
  status
}) => {
  const variantStatus = () => {
    switch (status) {
      case EInvoiceStatus.CLOSED:
        return 'success';
      case EInvoiceStatus.DUE:
        return 'danger';
      case EInvoiceStatus.WILL_DUE:
        return 'warning';

      default:
        return '';
    }
  };
  return <Tag variant={status.replace(status, variantStatus())}>{status}</Tag>;
};

export default InvoiceStatusColumn;
